import type { CatalogListItem } from '@skupreme/api-contracts/core';
import { Column, TableHeader, Tooltip } from '@skupreme/shared/ui';
import { InfoIcon } from '@phosphor-icons/react';
import { tooltipTexts } from '@utility/constants/common';
import {
  CatalogTableFrame,
  type CatalogTablePaging,
} from './CatalogTableFrame';
import {
  CATALOG_COLUMN_COUNT,
  type CatalogRowContext,
  CatalogRows,
} from './CatalogRows';
import { openableItemIds } from '../../lib/item-navigation';

export type CatalogTableProps = CatalogTablePaging & {
  items: CatalogListItem[];
  rowContext: CatalogRowContext;
};

export function CatalogTable({
  items,
  rowContext,
  ...paging
}: CatalogTableProps) {
  const pageItemIds = openableItemIds(items);

  return (
    <CatalogTableFrame
      aria-label="Catalog"
      columnCount={CATALOG_COLUMN_COUNT}
      header={
        <TableHeader>
          <Column id="p_sku" isRowHeader allowsSorting className="sk:w-[38%]">
            Product
          </Column>
          <Column id="price" className="sk:w-[10%]">
            Price
          </Column>
          <Column id="tags" className="sk:w-[14%]">
            Tags
          </Column>
          <Column id="total_inventory" allowsSorting className="sk:w-[12%]">
            <AvailableUnitsHeader />
          </Column>
          <Column id="marketplaces" className="sk:w-[22%]">
            Marketplaces
          </Column>
          <Column id="actions" aria-label="Actions" className="sk:w-[4%]">
            {''}
          </Column>
        </TableHeader>
      }
      rows={items.map(item => (
        <CatalogRows
          key={item._id}
          item={item}
          context={rowContext}
          pageItemIds={pageItemIds}
        />
      ))}
      {...paging}
    />
  );
}

export function AvailableUnitsHeader() {
  return (
    <Tooltip content={tooltipTexts.availableUnits}>
      <span className="sk:inline-flex sk:items-center sk:gap-1">
        Available units
        <InfoIcon size={12} aria-hidden />
      </span>
    </Tooltip>
  );
}
